import React from "react";
import {
  SCHOOL_KIND_ESF,
  SCHOOL_KIND_SKI_COOL,
  SCHOOL_KIND_SNOW_SYSTEMS,
  getSchoolKind,
} from "../utils/school-kinds";
import ESF from "./esf";
import SnowSystems from "./snow-systems";
import SkiCool from "./ski-cool";

export default function IconBySchool(props) {
  const { school, ...iconProps } = props;

  const schoolKind = getSchoolKind(school);

  if (schoolKind === SCHOOL_KIND_ESF) return <ESF {...iconProps} />;
  if (schoolKind === SCHOOL_KIND_SKI_COOL) return <SkiCool {...iconProps} />;
  if (schoolKind === SCHOOL_KIND_SNOW_SYSTEMS)
    return <SnowSystems {...iconProps} />;
  return null;
}
